import { deleteComma } from '@/utils/number';
import { ServiceData } from '..';
/**
 * 서버로 보내야 하는 데이터들의 공통 분모와 공통 로직을 추가 한다.
 */
// eslint-disable-next-line import/prefer-default-export
export class AbsDeliveryCharge extends ServiceData {
    /** 사용하지 않음 */
    reqBody;
    constructor(form) {
        super();
        this.reqBody = {
            ...form,
            businessHourStart: form.businessHourStart?.replaceAll(':', ''),
            businessHourEnd: form.businessHourEnd?.replaceAll(':', ''),
            charge: deleteComma(form.charge, true),
            surcharge: deleteComma(form.surcharge, true),
        };
        // view layer의 formData를 서버가 받을 형태로 가공한다.
        // Object.assign(this, {
        //   ...form,
        //   businessHourStart: data.businessHourStart?.replaceAll(':', ''),
        //   businessHourEnd: data.businessHourEnd?.replaceAll(':', ''),
        //   charge: deleteComma(data.charge, true),
        //   surcharge: deleteComma(data.surcharge, true),
        // });
    }
}
